import classNames from "classnames";
import _uniqueId from "lodash/uniqueId";
import type { InputHTMLAttributes } from "react";
import React, { forwardRef, useEffect, useMemo, useState } from "react";

import LineShortIcon from "@components/atoms/Icon/svg/check.svg?react";

import Icon from "@atoms/Icon";

interface IProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  className?: string;
  children?: React.ReactNode;
}

const Checkbox = forwardRef<HTMLInputElement, IProps>(({ label, className, children, ...props }: IProps, ref) => {
  const id = useMemo(() => props.id ?? `checkbox-${_uniqueId()}`, [props.id]);
  const [isChecked, setIsChecked] = useState<boolean>(props.checked ?? false);

  useEffect(() => {
    setIsChecked(props.checked!);
  }, [props.checked]);

  return (
    <span className={classNames(className)}>
      <input
        id={id}
        onChange={(e) => {
          setIsChecked(e.target.checked);
          props.onChange?.(e);
        }}
        ref={ref}
        type="checkbox"
        {...props}
      />
      <label className="inline-flex cursor-pointer items-start gap-1 font-regular" htmlFor={id}>
        <div className="flex h-5 items-center">
          <span className={classNames("relative inline-block size-3.5 rounded-xs border border-black")}>
            {isChecked ? <LineShortIcon className="center absolute" height="20px" width="20px" /> : null}
          </span>
        </div>
        <div>{children ?? (Boolean(label) && <span>{label}</span>)}</div>
      </label>
    </span>
  );
});

export default Checkbox;
